import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Snackbar } from "@bookips/sds";
import { Provider, Viewport } from "@radix-ui/react-toast";
import { cva } from "class-variance-authority";
import useSnackbar from "src/store/useSnackbar";
const snackbarViewportVariants = cva("fixed flex flex-col gap-1 top-[48px] right-[50%] z-snackbar w-[340px] translate-x-[50%]");
const SnackbarProvider = (param)=>{
    let { duration =3000 , children , ...props } = param;
    const { snackbars , remove  } = useSnackbar();
    return /*#__PURE__*/ _jsxs(Provider, {
        duration: duration,
        ...props,
        children: [
            /*#__PURE__*/ _jsx(Viewport, {
                className: snackbarViewportVariants()
            }),
            snackbars.map((snackbar)=>/*#__PURE__*/ _jsx(Snackbar, {
                    ...snackbar,
                    // SDS 아이콘에 shrink-0이 없어 메시지가 길어지면 눌린다. SDS 반영되면 제거
                    classes: {
                        title: "[&>svg]:shrink-0"
                    },
                    onOpenChange: (open)=>!open && remove(snackbar.id)
                }, snackbar.id)),
            children
        ]
    });
};
export default SnackbarProvider;
